import script from "./H3Text.vue?vue&type=script&setup=true&lang=js"
export * from "./H3Text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__